import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { ServiceFilterViewModel, ServiceTimeDetailViewModel } from '../../business-entities/ServiceFilter-viewModel';
import { BrandService } from '../../business-services/brand.service';

@Component({
  selector: 'app-service-duration-price',
  templateUrl: './service-duration-price.component.html'
})
export class ServiceDurationPriceComponent implements OnInit {
  
  @Input() in: number;
  @Input() service: ServiceTimeDetailViewModel;
  @Input() serviceFilter: ServiceFilterViewModel;
  @Input() isRemoveView: boolean = false;
  @Input() isAddView: boolean = false;
  @Output() addServiceTimeDetailSlotOpt = new EventEmitter<number>();
  @Output() removeServiceTimeDetailSlotOpt = new EventEmitter<number>();

  dropdownSettings = {};
  VATPercentage: number = 0
  constructor(
    private toaster: ToastrService, private translate: TranslateService,
    private secureStorage: SecureStorage,
    private brandService: BrandService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'fuelCodeAndType',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false,
      maxHeight: 500
    };
   this.onMakeSelected(this.serviceFilter.BrandId,false)
    this.VATPercentage = this.secureStorage.getKeyData('VATPercentage');
  }

  onChangeService(serviceId: any): void {
    if (serviceId == null) {
      this.serviceFilter.FuelTypeId = [];
    } else {
      if (serviceId.length == 0) {
        this.serviceFilter.FuelTypeId = [];
      }
    }
  }

  isDigit(event): void {
    const isDigit = Utility.isDigit(event);
    if (!isDigit) {
      event.preventDefault();
    }
  }

  onBlur(event) {
    this.serviceFilter.Price = event.target.value;
    let priceVal = JSON.parse(JSON.stringify(event.target.value));
    this.serviceFilter.PriceInclVAT = Utility.GetPriceInludingVAT(priceVal, this.VATPercentage).toString();
  }

  onChecked(obj: any, isChecked: boolean) {
    //TODO :
  }

  RemoveServiceFilter(index: number) {
    this.removeServiceTimeDetailSlotOpt.emit(index);
  }

  checkDiscount(event): void {
    const isDigit = Utility.isDigit(event);
    const isDecimalPoint = Utility.isDecimalPoint(event);
    if (!isDecimalPoint && !isDigit) {
      event.preventDefault();
    }
  }
  AddServiceFilter(index: number) {


    if (!this.serviceFilter.Duration || !this.serviceFilter.Price) {
      if (!(this.serviceFilter.BrandId || (this.serviceFilter.FuelTypeId.length > 0) || this.serviceFilter.VehicleTypeId)) {
        let errormsg = this.translate.instant("lblPleaseProvideAtleastOneFilter");
        this.toaster.error(errormsg);
        return;
      }
      else {
        let errormsg = this.translate.instant("lblPleaseProvideMandatoryValue");
        this.toaster.error(errormsg);
        return;
      }
    }
    this.addServiceTimeDetailSlotOpt.emit(index);
  }


  async GetAllModel(make: string): Promise<void> {
    await this.brandService.GetModelnoDropdownList(make).then(data => {
      this.service.modelList = data.responseObject;
    });
  }
  async onMakeSelected(make: any, makeChanged: boolean) {
    const selectedBrandId = make;
    const selectedBrand = this.service.makeList.find(type => type.id === selectedBrandId);
    if(makeChanged){
      this.serviceFilter.Model = null;
    }
    if (selectedBrand) {
      const selectedBrandCode = selectedBrand.brandCode;
      if (selectedBrandCode?.trim()) {
        this.GetAllModel(selectedBrandCode);
      } else {
        this.service.modelList = [];
      }
    }
    this.cdr.detectChanges();
  }
}
